import { Col, Row, Navbar, Container } from "react-bootstrap";
import { useState, useEffect, useContext, useRef } from "react";
import RegisterModal from "../RegisterModal";
import LoginModal from "../LoginModal";
import Forgot from "../Forgot";
import AuthContext from "@serie3/common/auth/AuthContext";
import firebaseConfig from "@serie3/freelancesplaceapi/Config/Firebase/firebase";
import { initializeApp, getApps } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";

// Initialise Firebase once at module level — never re-runs on re-render
const firebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const firebaseAuth = getAuth(firebaseApp);

const isDemo = typeof window !== "undefined" && window.location.hostname === "demo.freelancersplace.net";

const FEATURES = [
  { label: "Billing", href: "/billing" },
  { label: "CRM", href: "/crm" },
  { label: "Time Tracking", href: "/timetracking" },
  { label: "Projects", href: "/projects" },
];

const FreelancerserplaceNavbar = ({
  showLinks = true,
  showButtons = true,
}) => {
  const [showRegister, setShowRegister] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [showFeaturesMenu, setShowFeaturesMenu] = useState(false);
  const featuresRef = useRef(null);

  const { token } = useContext(AuthContext);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (featuresRef.current && !featuresRef.current.contains(e.target)) {
        setShowFeaturesMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <RegisterModal
        show={showRegister}
        setShow={setShowRegister}
        setShowLogin={setShowLogin}
      />
      <LoginModal
        show={showLogin}
        setShow={setShowLogin}
        setShowRegister={setShowRegister}
        setShowForgot={setShowForgot}
      />
      <Forgot show={showForgot} setShow={setShowForgot} />
      <Navbar className="lp-navbar">
        <Container>
          <Row className="justify-content-center col align-items-center py-3">
            <Col style={{ display: "inline-flex", alignItems: "center" }}>
              <a href="/">
                <img src="/dist/img/logo-1.jpg" alt="FreelancersPlace" style={{ maxHeight: "28px", width: "auto" }} />
              </a>
            </Col>
            <Col
              className="justify-content-center"
              style={{ display: "inline-flex", alignItems: "center", gap: "2rem" }}
            >
              {showLinks ? (
                <>
                  <div className="lp-dropdown-wrapper" ref={featuresRef}>
                    <button
                      className="headerLink lp-dropdown-trigger"
                      onClick={() => setShowFeaturesMenu((v) => !v)}
                    >
                      Features
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" style={{ marginLeft: "0.35rem", transition: "transform 0.2s", transform: showFeaturesMenu ? "rotate(180deg)" : "rotate(0deg)" }}>
                        <path d="M1 1L5 5L9 1" stroke="#4D4D4D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                    {showFeaturesMenu && (
                      <div className="lp-dropdown-menu">
                        {FEATURES.map(({ label, href }) => (
                          <a key={label} href={href} className="lp-dropdown-item" onClick={() => setShowFeaturesMenu(false)}>
                            {label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                  <a href="/#pricing" className="headerLink">
                    Pricing
                  </a>
                </>
              ) : null}
            </Col>
            {showButtons && (
              <Col className="justify-content-end" style={{ display: "inline-flex", alignItems: "center", gap: "0.6rem" }}>
                {!token ? (
                  <>
                    <button className="lp-nav-btn-ghost" onClick={() => setShowLogin(true)}>Login</button>
                    {!isDemo && (
                      <button className="lp-nav-btn-primary" onClick={() => setShowRegister(true)}>Sign up free</button>
                    )}
                  </>
                ) : (
                  <>
                    <button className="lp-nav-btn-ghost" onClick={() => signOut(firebaseAuth)}>Logout</button>
                    <button className="lp-nav-btn-primary" onClick={() => { window.location.href = "/"; }}>Dashboard</button>
                  </>
                )}
              </Col>
            )}
          </Row>
        </Container>
      </Navbar>
    </>
  );
};

export default FreelancerserplaceNavbar;
